// pbs-labels.js — chargé une fois, sur toutes les pages produit et listing.
// Lit les blocs <script type="application/json" data-pbs-labels"> générés par
// snippets/pbs-labels-data.liquid et insère chaque Label dans le DOM, au bon
// endroit (target_selector_product/listing) et dans la bonne position
// (before/after/prepend/append), avec ses couleurs, son contour, son padding
// et son éventuelle image de fond.
document.querySelectorAll('script[data-pbs-labels]').forEach(function (script) {
  var items;
  try {
    items = JSON.parse(script.textContent);
  } catch (e) {
    return;
  }

  var insertMap = {
    before: 'beforebegin',
    after: 'afterend',
    prepend: 'afterbegin',
    append: 'beforeend'
  };

  // Portée de la recherche : sur une page listing, un sélecteur comme ".price"
  // existe une fois PAR carte produit — document.querySelector() ne trouverait
  // que la toute première occurrence de la page, pas celle de la bonne carte.
  // On cherche donc d'abord dans la carte produit la plus proche du bloc de
  // données (.card-wrapper est la classe standard du thème Dawn pour ce
  // conteneur ; à ajuster si votre thème utilise un autre nom), et seulement
  // à défaut on retombe sur toute la page (cas de la fiche produit, où il n'y
  // a qu'une seule occurrence de chaque sélecteur).
  var scope = script.closest('.card-wrapper') || document;

  items.forEach(function (item) {
    var target = scope.querySelector(item.selector);
    if (!target) return;

    var el = document.createElement('span');
    el.className = 'pbs-label';
    el.textContent = item.label || '';

    if (item.textColor) el.style.color = item.textColor;
    if (item.backgroundColor) el.style.backgroundColor = item.backgroundColor;

    if (item.borderWidth) {
      el.style.borderWidth = item.borderWidth + 'px';
      el.style.borderStyle = 'solid';
      el.style.borderColor = item.borderColor || 'transparent';
    }

    el.style.paddingTop = (item.paddingTop || 0) + 'px';
    el.style.paddingRight = (item.paddingRight || 0) + 'px';
    el.style.paddingBottom = (item.paddingBottom || 0) + 'px';
    el.style.paddingLeft = (item.paddingLeft || 0) + 'px';

    if (item.backgroundImage) {
      el.style.backgroundImage = 'url(' + item.backgroundImage + ')';
      if (item.backgroundCover) {
        el.style.backgroundSize = 'cover';
        el.style.backgroundRepeat = 'no-repeat';
      } else {
        var repeatX = item.backgroundRepeatX ? 'repeat' : 'no-repeat';
        var repeatY = item.backgroundRepeatY ? 'repeat' : 'no-repeat';
        el.style.backgroundRepeat = repeatX + ' ' + repeatY;
      }
    }

    // CSS libre optionnel (champ custom_css du metaobject Label) : permet un
    // réglage ponctuel (ex. "text-align: right;") sans toucher aux fichiers du
    // thème. Ajouté APRÈS tous les styles ci-dessus pour pouvoir les surcharger
    // au cas par cas ; propriété par propriété, comme une balise style="" classique.
    if (item.customCss) {
      var currentStyle = el.getAttribute('style') || '';
      el.setAttribute('style', currentStyle + ';' + item.customCss);
    }

    target.insertAdjacentElement(insertMap[item.position] || 'afterend', el);
  });
});
